import { createSlice } from '@reduxjs/toolkit';

import type { DecodedToken } from './types';

export const slice = createSlice({
    initialState: {
        accessToken: undefined as string | undefined,
        decodedToken: undefined as DecodedToken | undefined
    },

    name: 'useAccessToken',

    reducers: {
        accessToken: (state, action) => {
            state.accessToken = action.payload;
        },

        decodedToken: (state, action) => {
            state.decodedToken = action.payload;
        }
    }
});

export default slice.reducer;
